import { Controller } from "@hotwired/stimulus";
import "./component.scss";

/**
 * Playlist Item Navigation Controller
 *
 * Handles keyboard navigation for playlist items using arrow keys.
 * Left arrow navigates to previous item, right arrow to next.
 *
 * Note: This controller shares identical logic with lesson_navigation.
 * If you modify this file, consider updating the sister component as well.
 * See: app/frontend/components/lesson_navigation/component.js
 */
export default class extends Controller {
  static targets = ["previousLink", "nextLink"];

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this);
    document.addEventListener("keydown", this.handleKeydown);
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown);
  }

  handleKeydown(event) {
    // Don't trigger if user is typing in an input field
    if (this.isInputFocused()) return;

    // Don't trigger if modifier keys are pressed
    if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey)
      return;

    switch (event.key) {
      case "ArrowLeft":
        this.navigatePrevious(event);
        break;
      case "ArrowRight":
        this.navigateNext(event);
        break;
    }
  }

  navigatePrevious(event) {
    if (this.hasPreviousLinkTarget) {
      event.preventDefault();
      this.previousLinkTarget.click();
    }
  }

  navigateNext(event) {
    if (this.hasNextLinkTarget) {
      event.preventDefault();
      this.nextLinkTarget.click();
    }
  }

  isInputFocused() {
    const activeElement = document.activeElement;
    const tagName = activeElement?.tagName?.toLowerCase();

    return (
      tagName === "input" ||
      tagName === "textarea" ||
      tagName === "select" ||
      activeElement?.isContentEditable
    );
  }
}
